import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DaoService } from 'src/app/servicos/dao.service';

@Component({
  selector: 'app-inscritor',
  templateUrl: './inscritor.component.html',
  styleUrls: ['./inscritor.component.css']
})
export class InscritorComponent implements OnInit {

  constructor(public dao: DaoService,private route: ActivatedRoute,public formBuilder: FormBuilder,private loader: NgxUiLoaderService) { }

  sub:any;
  idEvento:any;
  evento:any;
  formulario:any;
  maskCPFCNPJ: string = "999.999.999-99";
  origens:any = [{label:'Selecione a origem...',value:null},
{label:'Aposentado',value:'Aposentado'},
{label:'Pensionista',value:'Pensionista'},
{label:'Servidor Ativo',value:'Servidor Ativo'},
{label:'Rep. Legislativo',value:'Representante do Legislativo'},
{label:'Rep. Sindicato',value:'Representante do Sindicato'},
{label:'Rep. Executivo',value:'Representante do Executivo'},
{label:'Conselheiro',value:'Conselheiro'},
{label:'Sociedade Civil',value:'Sociedade Civil'}
];
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.idEvento = params['id']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
      this.dao.submeter({id:this.idEvento},"obterEventoPorId").then(res=>{
        this.evento = res;
        if(this.evento.aberto=='nao'){
          this.fechado = true;
        }
        console.log(this.evento);
        
      });
   });
   this.carregarFormulario();
  }

  fechado: boolean = false;

  carregarFormulario(){
    this.formulario = this.formBuilder.group({
      
      
      nome:[null,Validators.required],
      cpf:[null,Validators.required],
      email:[null,Validators.required],
      origem:[null,Validators.required]
      
      

    });
  }

   validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

validarEmail(){
  let d = this.formulario.controls.email.value;
  if(!this.validateEmail(d)){
    this.formulario.controls.email.setValue(null);
    this.dao.toast('e','Endereço de email inválido.');
  }

}

inscrito:any = false;

  async salvar(){
    if(!await this.verificarCPF()){
      return;
    }
    this.loader.start();
    this.validarEmail();
    if(this.formulario.valid){
      let dados = JSON.parse(JSON.stringify(this.formulario.value));
      console.log(dados);
      dados.idEvento = this.evento.id;
      this.dao.submeter(dados,'realizarInscricao').then(res=>{
        
        if(res['resultado']=='sucesso'){
          this.inscrito = true;
          this.loader.stop();
          this.dao.toast('s','Inscrição Realizada com Sucesso!');
        }

        if(res['resultado']=='limite'){
          // this.inscrito = true;
          this.loader.stop();
          this.dao.toast('e','Número de Inscrições atingido. <br> Infelizmente todas as vagas já foram preenchidas.<br> Para mais informações ligue pra nós: <b>(37)3215-7400</b>');
        }
      }).catch(er=>{
        this.loader.stop();
      });
      return;
    }
    
    this.dao.toast('e','Formulário Inválido, preencha todos os campos.');
    this.loader.stop();
  }

  async verificarCPF(){
    console.log("Verificando CPF");
    let cp = this.formulario.controls.cpf.value;
    let res = await this.dao.submeter({idEvento:this.evento.id,cpf:cp},'checarCPFExistente');
      if(res['resposta']=='naoPode'){
        this.formulario.controls.cpf.setValue(null);
        this.dao.toast('e','CPF já está cadastrado neste evento');
        return false;
      }

      return true;
    
  }

  verificaValidTouched(campo) {
    return !this.formulario.get(campo).valid && this.formulario.get(campo).touched;
  }

}
